<template>
    <modal ref="modal" unclosable>
      <div id="sub-wrapper">
        <div class="content">
          <div v-if="content" v-html="content"></div>
          <slot v-else></slot>
        </div>
        <button @click="onYes">{{ yes }}</button>
        <button class="button-2" @click="onNo">{{ no }}</button>
      </div>
    </modal>
</template>

<script>
export default {
  data () {
    return {
      content: '',
      no: '',
      reject: null,
      resolve: null,
      yes: ''
    }
  },
  methods: {
    show (content, yes, no) {
      this.content = content
      this.yes = yes
      this.no = no
      this.$refs.modal.show()
      return new Promise(function (resolve, reject) {
        this.resolve = resolve
        this.reject = reject
      }.bind(this))
    },
    hide () {
      this.$refs.modal.hide()
    },
    onYes () {
      if (this.resolve) this.resolve()
      this.hide()
    },
    onNo () {
      if (this.reject) this.reject()
      this.hide()
    }
  }
}
</script>

<style scoped>

#sub-wrapper .content {
  font-size: 1em;
  margin-bottom: 1.5em;
}

#sub-wrapper button {
  margin-right: 1em;
}

#sub-wrapper button:last-child {
  margin-right: 0;
}

#sub-wrapper span {
  cursor: pointer;
}

#sub-wrapper span:hover {
  text-decoration: underline;
}

#sub-wrapper .button-2 {
    background-color: #7c7c7c;
    color: #ffffff;
}

#sub-wrapper .button-2:hover {
    background-color: #8c8c8c;
    color: #ffffff;
}

</style>
